import React, { Component } from 'react'
import PropType from 'prop-types'
import config from 'config'
import Dropdown from 'components/dropdown'
import CtaButton from 'components/cta-button'
import { rewardsTypeOptions, creditScoreOptions } from 'components/dropdown/dropdown-options'
import { fireGtmEvent } from 'utils/gtm'
import { reduxForm } from 'redux-form'
import { compose } from 'redux'
import PoweredBy from 'components/powered-by'
import styles from '../personal/styles.scss'

class CreditCardForm extends Component {
  static propTypes = {
    widgetContext: PropType.object.isRequired,
    ctaText: PropType.string.isRequired,
    queryString: PropType.string.isRequired,
    metaQuery: PropType.string,
  }

  constructor(props) {
    super(props)

    this.state = {
      href: `${config.credibleRoot}/credit-cards/all-credit-cards`,
      rewardsType: 'all-credit-cards',
      creditScore: '',
    }
  }

  render() {
    const { ctaText } = this.props,
      { href } = this.state

    return (
      <>
        <section className={styles.form}>
          <div className="rewards-type mb-8">
            <Dropdown
              name="rewardsType"
              label="Card type"
              placeholder="Card type"
              options={rewardsTypeOptions}
              onChange={this.onChange}
            />
          </div>
          <div className="credit-score mb-16">
            <Dropdown
              name="creditScore"
              label="Estimated credit score"
              placeholder="Estimated credit score"
              options={creditScoreOptions}
              onChange={this.onChange}
            />
          </div>
        </section>
        <section className={styles.submit}>
          <CtaButton
            href={href}
            onClick={this.onClick}
            blank
            fullWidth
          >
            {ctaText}
          </CtaButton>
          <PoweredBy className="mt-8" />
        </section>
      </>
    )
  }

  onChange = (evt) => {
    const { value, name } = evt.target,
      { widgetContext } = this.props

    this.setState({
      [name]: value,
    })

    fireGtmEvent('fieldChange', { ...widgetContext, [name]: value })
  }

  onClick = () => {
    const { widgetContext, queryString, metaQuery } = this.props,
      { rewardsType, creditScore } = this.state,
      setCreditScore = creditScore ? `?creditScore=${creditScore}` : '',
      setQueryString = setCreditScore ? `&${queryString}${metaQuery}` : `?${queryString}${metaQuery}`

    this.setState({
      href: `${config.credibleRoot}/credit-cards/${rewardsType}${setCreditScore}${setQueryString}`,
    })

    fireGtmEvent('ctaClick', { ...widgetContext, rewardsType, creditScore })
  }
}

export { CreditCardForm }

export default compose(
  reduxForm({ form: 'credit-card-form' }),
)(CreditCardForm)
